import { getValidTranslations } from "@/@core/utils/translation_helpers";
import { formatFormFields } from "@/@core/utils/form_helpers";
import httpClient from "@/plugins/axios";
import moment from "moment";

export const getSurveysList = async (page, pageSize, query) => {
    const params = {
        page: page,
        page_size: pageSize,
    }
    if (query) {
        params['search'] = query;
    }
    const response = await httpClient.get(`/admin/v1/surveys/`, {
        params: params
    });
    return response;
}

export const getSurvey = async (surveyId) => {
    const response = await httpClient.get(`/admin/v1/surveys/${surveyId}/`);
    return response;
}

export const saveSurvey = async (survey) => {
    const payload = formatSurveyPayload(survey);
    if (survey.id) {
        return await updateSurvey(survey.id, payload);
    } else {
        return await insertSurvey(payload);
    }
}

const insertSurvey = async (payload) => {
    const response = await httpClient.post('/admin/v1/surveys/', payload);
    return response;
}

const updateSurvey = async (id, payload) => {
    const response = await httpClient.put(`/admin/v1/surveys/${id}/`, payload);
    return response;
}

export const deleteSurvey = async (id) => {
    const response = await httpClient.delete(`/admin/v1/surveys/${id}/`);
    return response;
}

export const getSurveySubmissionsAnalytics = async (surveyId, filters = null) => {
    const params = {};

    if (filters) {
        params.filters = filters;
    }

    const response = await httpClient.get(`/admin/v1/surveys/${surveyId}/submissions/analytics/`, {
        params: params
    });
    return response;
}

export const getSurveySubmissions = async (surveyId, page = 1, pageSize = 50, filters = null) => {
    const params = {
        page: page,
        page_size: pageSize,
    };

    if (filters) {
        params.filters = filters;
    }

    const response = await httpClient.get(`/admin/v1/surveys/${surveyId}/submissions/`, {
        params: params
    });
    return response;
}

export const copySurvey = async (surveyId) => {
    const response = await httpClient.post(`/admin/v1/surveys/${surveyId}/copy/`);
    return response;
}

export const exportSurveySubmissions = async (surveyId, filters = null) => {
    const params = {};

    if (filters) {
        params.filters = filters;
    }

    const response = await httpClient.get(
        `/admin/v1/surveys/${surveyId}/submissions/export/`,
        {
            params: params,
            responseType: 'blob'
        }
    );
    return response;
}

const formatSurveyPayload = (survey) => {
    const payload = {
        translations: getValidTranslations(survey.translations, ['title', 'description']),
        group_ids: survey.group_ids || [],
        push_sent: survey.push_sent || false,
    };

    if (survey.id) {
        payload.id = survey.id;
    }

    // Format form data
    if (survey.form) {
        payload.form = {
            id: survey.form.id || null,
            anonymous: survey.form.anonymous,
            allow_multiple_submissions: survey.form.allow_multiple_submissions,
            release_date: survey.form.release_date ? moment(survey.form.release_date, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
            expire_date: survey.form.expire_date ? moment(survey.form.expire_date, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,
            fields: formatFormFields(survey.form.fields || [])
        };
    }

    return payload;
}

export default {
    getSurveysList,
    getSurvey,
    saveSurvey,
    deleteSurvey,
    getSurveySubmissionsAnalytics,
    getSurveySubmissions,
    copySurvey,
    exportSurveySubmissions
}
